// extracted by mini-css-extract-plugin
export default {"errorMessage":"MySelect_errorMessage__UShUw","select":"MySelect_select__QanWH"};